import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Spinner } from "react-bootstrap";
import "./FileUploadModal.scss";

function Fileopenmodal({
  show,
  handleClose,
  rootItems,
  fetchFolderContent,
  setShowOneDrive,
  registerWebhook,
  userEmail,
  siteID,
  driveId,
  fetchSharePointSites,
  fetchSharePointFolderChildren,
  loadingData,
  fetchSharePointFolderFiles,
}) {
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [currentFolders, setCurrentFolders] = useState(rootItems);
  const [folderStack, setFolderStack] = useState([]);
  const [isFolderView, setIsFolderView] = useState(false);
  const source = localStorage.getItem("source");
  const [sharepointStage, setSharepointStage] = useState(null);

  useEffect(() => {
    if (show) {
      setCurrentFolders(rootItems);
      setFolderStack([]);
      setSelectedFolder(null);
    }
  }, [show, rootItems]);
  const handleFolderClick = async (folder) => {
    try {
      if (source === "sharepoint") {
        setSelectedFolder(folder);
      }

      if (source === "oneDrive") {
        const fullContent = await fetchFolderContent(folder.id, true);
        setSelectedFolder({
          ...folder,
          parentReference:
            fullContent?.parentReference ?? folder.parentReference,
          createdBy: fullContent?.createdBy ?? folder.createdBy,
        });
      }
    } catch (error) {
      console.error("Error fetching folder info:", error);
    }
  };
  const handleOpenClick = async () => {
    if (!selectedFolder) return;

    try {
      const newStack = [
        ...folderStack,
        {
          folders: currentFolders,
          isFolderView,
          sharepointStage,
        },
      ];
      if (source === "sharepoint") {
        if (!isFolderView) {
          const res = await fetchSharePointSites(selectedFolder.id, true);
          if (res.stage === "drive") {
            setIsFolderView(true);
            setCurrentFolders(res.data);
          }
        }
        if (isFolderView && sharepointStage == null) {
          const res = await fetchSharePointFolderChildren(
            selectedFolder.id,
            true
          );

          setSharepointStage(res.stage);
          setCurrentFolders(res.data.filter((item) => item.folder));
        }

        if (isFolderView && sharepointStage === "root") {
          const fileRes = await fetchSharePointFolderFiles(
            selectedFolder.id,
            selectedFolder?.parentReference?.driveId,
            true
          );
          setSharepointStage(fileRes.stage);
          setCurrentFolders(fileRes.data.filter((item) => item.folder));
        }
        if (isFolderView && sharepointStage === "file") {
          const fileRes = await fetchSharePointFolderFiles(
            selectedFolder.id,
            selectedFolder?.parentReference?.driveId,
            true
          );
          setSharepointStage(fileRes.stage);
          setCurrentFolders(fileRes.data.filter((item) => item.folder));
        }
      } else if (source === "oneDrive") {
        const subFolders = await fetchFolderContent(selectedFolder.id, true);
        setCurrentFolders(subFolders);
      }

      setFolderStack(newStack);
      setSelectedFolder(null);
    } catch (error) {
      console.error("Error opening folder:", error);
    }
  };

  const handleSelectClick = async () => {
    if (selectedFolder) {
      if (source == "sharepoint") {
        try {
          const email = selectedFolder.createdBy?.user?.email || userEmail;
          if (sharepointStage === "root" || sharepointStage === "file") {
            var driveId = selectedFolder?.parentReference?.driveId;
            var folderId = selectedFolder?.id;
          } else {
            var driveId = selectedFolder?.id;
            var folderId = selectedFolder?.owner?.group?.id;
          }

          await registerWebhook(email, folderId, driveId, selectedFolder.name);
          close();
        } catch (error) {
          console.error("Error selecting folder:", error);
        }
      } else {
        try {
          await registerWebhook(
            userEmail,
            siteID,
            selectedFolder?.parentReference?.driveId,
            selectedFolder.name
          );
          close();
        } catch (error) {
          console.error("Error selecting folder:", error);
        }
      }
    }
  };
  const handleBackClick = () => {
    if (folderStack.length > 0) {
      const prevState = folderStack[folderStack.length - 1];
      const newStack = folderStack.slice(0, folderStack.length - 1);
      setCurrentFolders(prevState.folders);
      setIsFolderView(prevState.isFolderView);
      setSharepointStage(prevState.sharepointStage);
      setFolderStack(newStack);
      setSelectedFolder(null);
    }
  };

  const close = () => {
    setSelectedFolder(null);
    setCurrentFolders(rootItems);
    setFolderStack([]);
    handleClose();
    setShowOneDrive(false);
    setIsFolderView(false);
    setSharepointStage(null);
  };
  return (
    <Modal
      show={show}
      centered
      onHide={close}
      size="lg"
      className="custom-modal file-upload-modale"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {source === "sharepoint" ? "SharePoint Sites" : "OneDrive Folders"}
        </Modal.Title>
      </Modal.Header>

      {!loadingData ? (
        <Modal.Body>
          {folderStack?.length > 0 && (
            <button
              className="btn btn-secondary mb-2"
              onClick={handleBackClick}
            >
              Back
            </button>
          )}
          <div className="file-list">
            {(currentFolders?.length || 0) > 0 ? (
              <ul>
                {currentFolders.map((folder) => (
                  <li
                    key={folder.id}
                    className={`file-item ${
                      selectedFolder?.id === folder.id ? "selected" : ""
                    }`}
                    onClick={() => handleFolderClick(folder)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="rgba(0,97,175,1)"
                    >
                      <path d="M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2 3 3 3H10.4142L12.4142 5ZM20 11H4V19H20V11ZM20 9V7H11.5858L9.58579 5H4V9H20Z" />
                    </svg>{" "}
                    <span>
                      {source === "sharepoint"
                        ? folder.displayName || folder.name
                        : folder.name}
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="empty-message">No subfolders.</p>
            )}
          </div>
        </Modal.Body>
      ) : (
        <div className="d-flex align-items-center justify-content-center mt-2">
          <Spinner
            animation="border"
            style={{ width: "25px", height: "25px" }}
          />
        </div>
      )}

      <Modal.Footer>
        <div className="selected-folder">
          {selectedFolder ? (
            <input
              className="form-control"
              type="text"
              value={selectedFolder.name}
              aria-label={selectedFolder.name}
              disabled
              readOnly
            />
          ) : (
            <span>No folder selected</span>
          )}
        </div>
        <button
          className="btn btn-open me-2"
          onClick={handleOpenClick}
          disabled={!selectedFolder}
        >
          Open
        </button>

        <button
          className="btn btn-open me-2"
          onClick={handleSelectClick}
          disabled={
            !selectedFolder || (source === "sharepoint" && !isFolderView)
          }
        >
          Select
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default Fileopenmodal;
